import { Drawer as DrawerPrimitive } from "vaul";
import { triggerHaptic } from "@/lib/nativeHaptics";

export type ComingSoonMethod = "social" | "url" | "text";

interface ComingSoonSheetProps {
  open: boolean;
  method: ComingSoonMethod | null;
  onOpenChange: (open: boolean) => void;
}

const COPY: Record<
  ComingSoonMethod,
  { title: string; icon: string; body: string }
> = {
  social: {
    title: "Add from social media",
    icon: "ti-brand-instagram",
    body: "We're building share-from-app support for TikTok, Instagram and Pinterest. We'll let you know when it's ready.",
  },
  url: {
    title: "Paste a URL",
    icon: "ti-link",
    body: "We're building URL import for retailer pages and social posts. Coming soon.",
  },
  text: {
    title: "Describe an outfit",
    icon: "ti-text-plus",
    body: "We're building AI-powered outfit creation from text descriptions. Coming soon.",
  },
};

export default function ComingSoonSheet({
  open,
  method,
  onOpenChange,
}: ComingSoonSheetProps) {
  const copy = method ? COPY[method] : null;

  return (
    <DrawerPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DrawerPrimitive.Portal>
        <DrawerPrimitive.Overlay
          className="fixed inset-0 z-[70]"
          style={{ background: "rgba(44,40,32,0.4)" }}
        />
        <DrawerPrimitive.Content
          className="fixed inset-x-0 bottom-0 z-[71] flex flex-col"
          style={{
            background: "#FFFCF8",
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            paddingBottom: "calc(16px + var(--safe-bottom))",
            outline: "none",
          }}
        >
          <div
            aria-hidden="true"
            style={{
              width: 36,
              height: 4,
              borderRadius: 999,
              background: "#E0D8D0",
              margin: "8px auto",
            }}
          />
          {copy && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  padding: "0 16px 4px",
                }}
              >
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    className="l2f-type-section-header"
                    style={{ color: "#C84B2F" }}
                  >
                    COMING SOON
                  </div>
                  <DrawerPrimitive.Title
                    style={{
                      fontSize: 20,
                      fontStyle: "italic",
                      fontFamily:
                        "var(--font-serif), 'Instrument Serif', Georgia, serif",
                      color: "#2C2820",
                      lineHeight: 1.1,
                      marginTop: 2,
                      fontWeight: 400,
                    }}
                  >
                    {copy.title}
                  </DrawerPrimitive.Title>
                </div>
                <button
                  type="button"
                  aria-label="Close"
                  onClick={() => onOpenChange(false)}
                  style={{
                    width: 44,
                    height: 44,
                    background: "transparent",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    flexShrink: 0,
                    padding: 0,
                    margin: "-6px -6px 0 0",
                  }}
                >
                  <span
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: 999,
                      background: "#F1EFE8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className="ti ti-x"
                      style={{ fontSize: 14, color: "#4A4540" }}
                    />
                  </span>
                </button>
              </div>
              <DrawerPrimitive.Description className="sr-only">
                {copy.body}
              </DrawerPrimitive.Description>

              <div
                style={{
                  padding: "20px 24px 16px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    width: 80,
                    height: 80,
                    borderRadius: 999,
                    background: "#FAECE7",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 16,
                  }}
                >
                  <i
                    className={`ti ${copy.icon}`}
                    style={{ fontSize: 40, color: "#C84B2F" }}
                  />
                </div>
                <p
                  className="l2f-type-secondary"
                  style={{
                    color: "#4A4540",
                    margin: 0,
                    maxWidth: 320,
                  }}
                >
                  {copy.body}
                </p>
              </div>

              <div style={{ padding: "8px 16px 0" }}>
                <button
                  type="button"
                  onClick={() => {
                    void triggerHaptic("selection");
                    onOpenChange(false);
                  }}
                  style={{
                    width: "100%",
                    background: "#C84B2F",
                    color: "#FFFFFF",
                    border: "none",
                    borderRadius: 999,
                    padding: "14px 16px",
                    fontSize: 14,
                    fontWeight: 500,
                    cursor: "pointer",
                  }}
                >
                  Got it
                </button>
              </div>
            </>
          )}
        </DrawerPrimitive.Content>
      </DrawerPrimitive.Portal>
    </DrawerPrimitive.Root>
  );
}
